// src/app/services/seo.service.ts
import { Injectable, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SeoService {
    private renderer: Renderer2;

    constructor(
        private titleService: Title,
        private metaService: Meta,
        @Inject(DOCUMENT) private document: Document,
        rendererFactory: RendererFactory2
    ) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    updateTitle(title: string): void {
        this.titleService.setTitle(title);
    }

    updateDescription(desc: string): void {
        this.metaService.updateTag({ name: 'description', content: desc });
    }

    updateCanonical(url?: string): void {
        // console.log("SEO-Service:updateCanonical-url", url);
        const urlX = url || this.document.location.href;
        const canonicalUrl = urlX;
        // if (!urlX?.endsWith("/en")) canonicalUrl += "/en";
        let link: HTMLLinkElement | null = this.document.querySelector("link[rel='canonical']");
        if (link) {
            link.setAttribute('href', canonicalUrl);
        } else {
            link = this.renderer.createElement('link');
            link!.setAttribute('rel', 'canonical');
            link!.setAttribute('href', canonicalUrl);
            this.renderer.appendChild(this.document.head, link);
        }
    }

    updateCanonicalForInfoPages(url?: string): void {
        const urlX = url || this.document.location.href;
        let canonicalUrl = urlX;
        // update /de urls
        if (!urlX?.endsWith("/de") && !urlX?.endsWith("/en")) {
            canonicalUrl += "/en";
        }
        // set link
        let link: HTMLLinkElement | null = this.document.querySelector("link[rel='canonical']");
        if (link) {
            link.setAttribute('href', canonicalUrl);
        } else {
            link = this.renderer.createElement('link');
            link!.setAttribute('rel', 'canonical');
            link!.setAttribute('href', canonicalUrl);
            this.renderer.appendChild(this.document.head, link);
        }
    }

    updateCanonicalForRouteAndCollectionPages(url?: string): void {
        const urlX = url || this.document.location.href;
        const canonicalUrl = urlX;
        // set link
        let link: HTMLLinkElement | null = this.document.querySelector("link[rel='canonical']");
        if (link) {
            link.setAttribute('href', canonicalUrl);
        } else {
            link = this.renderer.createElement('link');
            link!.setAttribute('rel', 'canonical');
            link!.setAttribute('href', canonicalUrl);
            this.renderer.appendChild(this.document.head, link);
        }
    }

    updateLanguage(lang: string): void {
        this.metaService.updateTag({ name: 'language', content: lang });
    }

    updateJsonLd(jsonLd: string): void {
        const script = document.createElement("script");
        // console.log("SeoService:updateJsonLd-script", script);
        script.type = "application/ld+json";
        script.textContent = jsonLd;
        document.head.appendChild(script);
    }

    setAlternateLink(lang: string, url: string) {
        const link = document.createElement('link');
        link.setAttribute('rel', 'alternate');
        link.setAttribute('hreflang', lang);
        link.setAttribute('href', url);
        document.head.appendChild(link);
    }

    clearRobots() {
        document.querySelectorAll('meta[name="robots"]').forEach(el => el.remove());
    }
    setRobots(value: string) {
        document.querySelectorAll('meta[name="robots"]').forEach(el => el.remove());

        let tag = document.querySelector('meta[name="robots"]') as HTMLMetaElement;

        if (!tag) {
            tag = document.createElement('meta');
            tag.setAttribute('name', 'robots');
            document.head.appendChild(tag);
        }

        tag.setAttribute('content', value);
    }
}